<template>
  <div class="contain page7-con" id="Mobile7">
    <div class="con">
      <div class="con-head title-box">
        <div class="title-chinese">
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
          <h3>新闻资讯</h3>
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
        </div>
        <div class="title-english">
          <p class="about" style="color: #666">NEWS</p>
        </div>
      </div>
      <div class="content myMain hidden-sm-and-down">
        <template>
          <div class="outSwiperBox">
            <swiper
              v-if="swiperData && swiperData.length > 0"
              loop
              ref="mySwiper"
              class="swiper"
              :options="swiperOption"
              style="height: 100%"
            >
              <swiper-slide v-for="(item, index) in swiperData" :key="index">
                <div @click="gotoDetail(item)">
                  <div class="img">
                    <img :src="item.img" :alt="index" />
                  </div>
                  <div class="info">
                    <p class="dateTime">{{ item.createdate }}</p>
                    <h3>{{ item.title }}</h3>
                    <p
                      v-html="delHtmlTag(item.content)"
                      class="vHtml-swiper"
                    ></p>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </template>
      </div>
      <div class="m-news hidden-md-and-up">
        <ul>
          <li
            v-for="(item, index) in swiperData"
            :key="index"
            @click="gotoDetail(item)"
          >
            <div class="info">
              <h3>{{ item.title }}</h3>
              <p v-html="delHtmlTag(item.content)" class="vHtml-swiper-m"></p>
            </div>
            <div class="img">
              <img :src="item.img" :alt="index" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getArticleList } from "@/api/home/index";
import { removeHtmlStyle } from "@/utils/removestyle";
import { delHtmlTag } from "@/utils/index.js";
export default {
  data() {
    return {
      params: {
        categorys: "新闻资讯",
        show: 1,
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 当用户滑动图片后继续自动轮播
        },
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        params: {
          categorys: "新闻资讯",
          show: 1,
        },
      },
      swiperData: [],
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    getArticleList(this.params).then((res) => {
      this.swiperData = res.data.list;
      this.swiperData.map((item) => {
        item.createdate = item.createdate.split("T")[0];
      });
    });
  },
  methods: {
    removeHtmlStyle,
    delHtmlTag,
    gotoDetail(item) {
      this.$router.push("/news/newsDetail?id=" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.page7-con {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
.page7-con .con {
  height: 100%;
  overflow: hidden;
  padding-top: 80px;
  padding-bottom: 60px;
  box-sizing: border-box;
  .con-head .el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .el-col-6 {
      width: 20%;
    }
    .el-col {
      h3 {
        font-size: 38px;
        color: #da5351;
      }
      .line {
        width: 85px;
        height: 2px;
        background-color: #d8d8d8;
        display: none;
      }
      .line:last-child {
        margin-top: 2px;
      }
    }
    p.about {
      font-size: 18px;
      margin-top: 16px;
      margin-bottom: 26px;
    }
  }
  .con-head {
    height: 15%;
  }
  .content {
    position: relative;
    height: 70%;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
    .outSwiperBox {
      height: 100%;
      position: relative;
      .swiper {
        position: initial;
        .swiper-slide {
          text-align: center;
          font-weight: bold;
          border: 1px solid #e6e6e6;
          cursor: pointer;
          // width: 380px;
          div.img {
            width: 100%;
            height: 206px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          div.info {
            box-sizing: border-box;
            color: #b2b2b2;
            height: 184px;
            width: 100%;
            padding: 0 20px;
            text-align: left;
            background: rgba(250, 250, 250, 0.73);
            p.dateTime {
              display: flex;
              line-height: 45px;
              height: 45px;
              border-bottom: 1px solid #dddddd;
              color: #b2b2b2;
            }
            h3 {
              font-size: 18px;
              color: #222222;
              margin: 12.5px 0;
              width: 100%;
              overflow: hidden;
              word-break: keep-all;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            p {
              color: #666666;
              font-size: 16px;
              display: flex;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              word-break: break-all;
            }
          }
        }
        .swiper-button-prev,
        .swiper-button-next {
          width: 36px;
          height: 36px;
          font-size: 28px;
          color: #999999;
          border: 2px solid #e4e4e4;
          border-radius: 50%;
          background-size: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: 50% 50%;
          -webkit-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: #999999;
        }
        .swiper-button-prev {
          left: -8%;
        }
        .swiper-button-next {
          right: -8%;
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  #Mobile7 {
    .con {
      padding-top: 0.24rem;
      padding-bottom: 0;
    }
    .m-news {
      ul {
        background: #ffffff;
        border-radius: 0.04rem;
        margin: 0.24rem 0.16rem;
        padding: 0.14rem 0.14rem 0 0.14rem;
        li {
          display: flex;
          align-items: flex-start;
          // padding-bottom: 0.12rem;
          border-bottom: 0.02rem #f1f1f1 solid;
          padding-bottom: 0.13rem;
          margin-bottom: 0.13rem;
          &:nth-child(n + 5) {
            display: none;
          }
          &:nth-child(4) {
            margin: 0;
            border: none;
          }
          .info {
            flex: 1;
            padding-right: 0.46rem;
            h3 {
              font-size: 0.16rem;
              font-weight: 500;
              color: #333333;
              line-height: 0.18rem;
              text-align: left;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            p {
              font-size: 0.12rem;
              font-weight: 400;
              line-height: 0.17rem;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin: 0.08rem 0 0;
            }
          }
          .img {
            width: 1rem;
            height: 0.6rem;

            img {
              border-radius: 0.04rem;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  background-color: #e6e6e6;
  opacity: 1;
}
//html的样式
.vHtml-swiper {
  p {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }
}
@media screen and (max-width: 960px) {
  #Mobile7 {
    .vHtml-swiper-m {
      text-align: left;
      font-size: 0.12rem;
      font-weight: 400;
      color: #b3b3b3;
      line-height: 0.17rem;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin: 0.08rem 0 0.14rem 0;
    }
  }
}
</style>
